// extracted by mini-css-extract-plugin
export var dayLabel = "_ka-0";
export var pickerDisabled = "_ka-1";